<div class="leaderboard-select-wrapper" fxLayout="row" [fxLayoutAlign]="host === 'evaluation' ? 'end center' : 'space-between center'" fxLayoutGap="16px">
  <uni-leaderboard-date-range-filter
    *ngIf="host !== 'evaluation'"
    placeholder="Voting period"
    [extraOptions]="['Voting period']"
    (dateRange)="filter($event)">
  </uni-leaderboard-date-range-filter>

  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" *ngIf="host === 'evaluation'">
    <uni-auxiliary-filter
      filterTitle="Select juror"
      type="juror"
      [options]="jurorFilterOptions"
      [chosenOption]="selectedJurorOption"
      [align]="'right'"
      (setOption)="setFilterOption($event, 'juror')">
    </uni-auxiliary-filter>
    <uni-auxiliary-filter
      filterTitle="Select criterion"
      type="criterion"
      [options]="categoryFilterOptions"
      [chosenOption]="selectedCriterionOption"
      [align]="'right'"
      (setOption)="setFilterOption($event, 'criterion')">
    </uni-auxiliary-filter>
  </div>
</div>

<div class="leaderboard-table-wrapper">
  <div class="leaderboard-table-container margin-y-8">
    <table class="leaderboard-table">
      <tr class="header-row">
        <th class="font-xs sparro-grey-800 font-regular text-left padding-x-2 orange-border"> Index </th>
        <th class="font-xs sparro-grey-800 font-regular text-left padding-x-2 orange-border"> Title </th>

        <th class="font-xs sparro-grey-800 font-regular text-left padding-x-2 orange-border"
          *ngIf="host === 'competition'"> Likes </th>

        <th class="orange-border">
          <div fxLayout="row">
            <i class="icon-arrow-dir-down sparro-grey-800 font-regular padding-top-1 cursor-pointer font-md"
              *ngIf="!likesAscending" (click)="applySorting(leaderboardEntries, 'effective_score', 'desc')"></i>

            <i class="icon-arrow-dir-up sparro-grey-800 font-regular padding-top-1 cursor-pointer font-md"
              *ngIf="likesAscending" (click)="applySorting(leaderboardEntries, 'effective_score', 'asc')"></i>

            <p class="font-xs sparro-grey-800 font-regular padding-right-1 margin-0 padding-top-1">Effective <br />
              Score</p>
          </div>
        </th>

        <th class="font-xs sparro-grey-800 font-regular text-center padding-x-2 margin-0 padding-top-1 orange-border"
          *ngIf="host === 'evaluation'">
          Filtered <br /> Score
        </th>

        <th class="orange-border" *ngIf="resultsAnnounced">
          <div fxLayout="row">
            <i class="icon-arrow-dir-down sparro-grey-800 font-regular padding-top-1 cursor-pointer font-md"
              *ngIf="!juryScoreAscending" (click)="applySorting(leaderboardEntries, 'average_score', 'desc')"></i>
            <i class="icon-arrow-dir-up sparro-grey-800 font-regular padding-top-1 cursor-pointer font-md"
              *ngIf="juryScoreAscending" (click)="applySorting(leaderboardEntries, 'average_score', 'asc')"></i>
            <p class="font-xs sparro-grey-800 font-regular padding-right-1 margin-0 padding-top-1">Final <br /> Score
            </p>
          </div>
        </th>

        <th class="font-xs sparro-grey-800 font-regular text-left padding-x-2 orange-border" *ngIf="shortlistedAnnounced">
          Results
        </th>

        <th class="orange-border" *ngIf="shortlistedAnnounced"></th>
      </tr>

      <ng-container *ngFor="let page of pagewiseEntries; index as i">
        <ng-container *ngIf="page.isCurrentPage">
          <ng-container *ngFor="let entry of page.entries; index as index">
            <tr [ngClass]="{'leaderboard-even-row': (index % 2 == 0), 'leaderboard-odd-row': (index % 2 == 1)}"
              style="height: 56px;">
              <td class="padding-x-3 text-left font-xs">
                {{ currentPage == 1 ? index + 1 : ((currentPage-1)*10) + index + 1 }}
              </td>

              <td fxLayout="row" fxLayoutAlign="space-between center"
                class="padding-left-2 padding-right-1 entry-title">
                <div fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="8px">
                  <uni-image
                    alt="entry-cover-image"
                    [src]="competitionEntryType === 'project' ? entry.project.image : competitionEntryType === 'blog' ? entry.blog.image : entry.publication.image"
                    [width]="32"
                    [height]="32"
                    auxClassList="entry-type-image">
                  </uni-image>
                  <p class="font-xs margin-right-1 cursor-pointer" (click)="getEntryDetail(entry)">
                    {{ (competitionEntryType === 'project' ? entry.project.title : competitionEntryType === 'blog' ?
                    entry.blog.title : entry.publication.title) | titlecase | truncate : 20 }}
                  </p>
                </div>
                <i (click)="openProjectNewWindow(entry)" style="margin-left: auto;"
                  class="badge-icon icon-open-in-new-tab-bold cursor-pointer margin-right-2"
                  matTooltip="Open in New Tab" matTooltipPosition="after"></i>
                <ng-container *ngIf="!shortlistedAnnounced">
                  <uni-image
                    (click)="createReport(entry, true)"
                    [src]="appealIcon"
                    alt="appeal-icon"
                    matTooltip="Appeal"
                    matTooltipPosition="after"
                    [width]="24"
                    [height]="24"
                    auxClassList="appeal-icon">
                  </uni-image>
                </ng-container>
              </td>

              <td class="padding-x-1 text-center font-xs" *ngIf="host === 'competition'">
                {{ competitionEntryType === 'project' ? entry.project.like.length : competitionEntryType === 'blog' ?
                entry.blog.like.length : entry.publication.like.length}}
              </td>

              <td class="padding-x-3 text-center font-xs"> {{ entry.effective_score.toFixed(2) }} </td>

              <td class="padding-x-3 text-center font-xs" *ngIf="host == 'evaluation'"> {{ entry?.filtered_score ?
                entry.filtered_score.toFixed(2) : '0.00' }} </td>

              <td class="padding-x-2 text-center font-xs" *ngIf="resultsAnnounced"> {{ entry?.average_score ?
                entry.average_score.toFixed(2) : 'NA' }} </td>

              <td class="padding-x-2 text-left font-xs" *ngIf="shortlistedAnnounced">
                <div fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="8px">
                  <ng-container *ngIf="!['Entries', 'Shortlisted'].includes(entry.entry_type.title)">
                    <ng-container *ngIf="entry.entry_type?.image; else defaultAwardIcon">
                      <uni-image [src]="entry.entry_type?.image" alt="award-icon" [width]="24" [height]="24"></uni-image>
                    </ng-container>
                    <ng-template #defaultAwardIcon>
                      <i class="icon-award font-lg"></i>
                    </ng-template>
                  </ng-container>
                  <p>{{ entry.entry_type.title }}</p>
                </div>
              </td>

              <td *ngIf="shortlistedAnnounced">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon class="icon-three-vertical-dots-fill font-md" style="vertical-align: text-bottom;">
                  </mat-icon>
                </button>

                <mat-menu #menu="matMenu">
                  <ng-container>
                    <button mat-menu-item (click)="openShareDialog(entry)">
                      <span>Share</span>
                    </button>
                    <button mat-menu-item (click)="createReport(entry)">
                      <span>Report</span>
                    </button>
                  </ng-container>
                </mat-menu>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
    </table>

    <div class="pagination-container padding-x-2 width-100" fxLayout="row"
      [fxLayoutAlign]="mobileView ? 'start center' : 'end center'" fxLayoutGap="16px">
      <div fxLayout="row" fxLayoutAlign="center center" style="height: inherit;">
        <p class="font-xs sparro-grey-900 font-light margin-right-2"> Rows per page: </p>
        <mat-select [(ngModel)]="pageOffset" class="font-xs sparro-grey-900 font-light">
          <mat-option *ngFor="let row of pageRows" [value]="row" (click)="changeRowsPerPage(row)"
            class="font-xs sparro-grey-900 font-light">
            {{ row }}
          </mat-option>
        </mat-select>
      </div>
      <p class="font-xs sparro-grey-900 font-light">
        {{ currentPage == 1 ? 1 : ((currentPage-1) * pageOffset)+1 }} - {{ currentPage == 1 ? pageOffset <
          leaderboardEntries.length ? pageOffset : leaderboardEntries.length : ( currentPage == lastPage ?
          leaderboardEntries.length : currentPage * pageOffset ) }} of {{ leaderboardEntries.length }}
        </p>
        <ng-container>
          <ng-container *ngIf="currentPage == 1; else currentPageIsNotPageOne">
            <uni-image
              src="https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/firstpagejump/grey_bold_48x48.svg"
              classes="cursor-not-allowed align-middle"
              [width]="24"
              [height]="24"
              alt="icon-go-to-first-page">
            </uni-image>
          </ng-container>
          <ng-template #currentPageIsNotPageOne>
            <uni-image
              src="https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/firstpagejump/black_bold_48x48.svg"
              (click)="goToPage('first')"
              classes="cursor-pointer align-middle"
              [width]="24"
              [height]="24"
              alt="icon-go-to-previous-page">
            </uni-image>
          </ng-template>
        </ng-container>
        <ng-container>
          <i class="icon-arrow-left-bold font-lg cursor-not-allowed sparro-grey-400" *ngIf="currentPage == 1"></i>
          <i class="icon-arrow-left-bold font-lg cursor-pointer" *ngIf="currentPage !== 1"
            (click)="goToPage('previous')"></i>
        </ng-container>
        <ng-container>
          <i class="icon-arrow-right-bold font-lg cursor-not-allowed sparro-grey-400"
            *ngIf="currentPage == lastPage"></i>
          <i class="icon-arrow-right-bold font-lg cursor-pointer" *ngIf="currentPage !== lastPage"
            (click)="goToPage('next')"></i>
        </ng-container>
        <ng-container>
          <ng-container *ngIf="currentPage == lastPage; else currentPageIsNotLastPage">
            <uni-image
              src="https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/lastpagejump/grey_bold_48x48.svg"
              classes="cursor-not-allowed align-middle"
              [width]="24"
              [height]="24"
              alt="icon-go-to-last-page">
            </uni-image>
          </ng-container>
          <ng-template #currentPageIsNotLastPage>
            <uni-image
              src="https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/lastpagejump/black_bold_48x48.svg"
              (click)="goToPage('last')"
              classes="cursor-pointer align-middle"
              [width]="24"
              [height]="24"
              alt="icon-go-to-last-page">
            </uni-image>
          </ng-template>
        </ng-container>
    </div>
  </div>
</div>

<!-- <p class="font-sm sparro-grey-800">How do we calculate the score?
  <i class="icon-info" matTooltip="Effective score = SUM ((Like A * Profile Score A) +(Like B * Profile Score B) + (Like C * Profile Score C)+...)" [matTooltipPosition]="'above'"></i>
</p> -->
